export default function Excel_Manage_Rules_CF() {
  return <div>Excel_Manage_Rules</div>;
}
